import { SerializedFarmConfig } from '@pancakeswap/farms'
import { coreTokens } from '@pancakeswap/tokens'

const farms: SerializedFarmConfig[] = [
  {
    pid: 4,
    lpSymbol: 'WCORE-USDT LP',
    lpAddress: '0xb5aC6a7f20e9ECF8CFEDF614741F78395c3F029d',
    quoteToken: coreTokens.wcore,
    token: coreTokens.usdt,
  },
].map((p) => ({ ...p, token: p.token.serialize, quoteToken: p.quoteToken.serialize }))

export default farms
